// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__17Qhe","footer":"ModalFilter_footer__1B8u2"};